module.exports = __webpack_public_path__ + "static/media/playlists-bold.4e759877.svg";